import { createContext, useContext, useRef } from "react";
import { Toast } from "primereact/toast";
import { useTranslation } from "react-i18next";

const ToastContext = createContext<{
    showToast: (message: any) => void;
    showToastTranslated: (message: any) => void;
}>(
    {
        showToast: () => { },
        showToastTranslated: () => { }
    });

export const ToastProvider = ({ children }: { children: React.ReactNode }) => {
    const toast = useRef<Toast>(null);
    const { t } = useTranslation('common');

    const showToast = (message: any) => {
        console.log("message", message)
        toast.current?.show(message);
    };

    // 🔹 Show toast with a translated message
    const showToastTranslated = (message: any) => {
        console.log("message", message)
        toast.current?.show({ // Default summary (ensure this exists in translations)
            severity: message.severity,
            summary: message.summary,
            detail: t(`${message.detail}`),  // Translated detail message
            life: 3000
        });
    };

    return (
        <ToastContext.Provider value={{ showToast, showToastTranslated }}>
            <Toast ref={toast} position="bottom-center" />
            {children}
        </ToastContext.Provider>
    );
};

export const useToast = () => useContext(ToastContext);
